module.exports = __webpack_public_path__ + "img/njcb.60c2fa0c.svg";